// tippi/src/pages/carrier/CarrierVehicles.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { useOrgVehicles } from '../../hooks/useOrgVehicles';
import { BODY_TYPE_LABEL, inspectionStatus, vehicleAvailability } from '../../utils/vehicleStatus';
import { ui, chip } from './carrierStyles';

export default function CarrierVehicles() {
  const { orgId, isStaff } = useCarrierOrg();
  const { vehicles, loading, error } = useOrgVehicles(orgId);

  return (
    <>
      <div style={{ ...ui.row, justifyContent: 'space-between' }}>
        <h1 style={ui.h1}>Biler</h1>
        {isStaff && <Link to="/transportor/biler/ny" className="tippi-btn" style={{ ...ui.btn, display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>Ny bil</Link>}
      </div>
      {error && <p role="alert" style={ui.error}>Kunne ikke hente bilene. Last siden på nytt.</p>}
      <div style={ui.card}>
        {loading && <p style={ui.hint}>Laster…</p>}
        {!loading && vehicles.length === 0 && <p style={ui.hint}>Ingen biler registrert ennå.</p>}
        {vehicles.map(v => {
          const availability = vehicleAvailability(v);
          const inspection = inspectionStatus(v);
          return (
            <Link key={v.id} to={`/transportor/biler/${v.id}`} style={{ ...ui.link, ...ui.listRow }}>
              <span>
                <strong>{v.registrationPlate}</strong>{' '}
                <span style={ui.hint}>{v.make} · {BODY_TYPE_LABEL[v.bodyType] ?? v.bodyType}</span>
                <span style={{ display: 'block', ...ui.hint }}>EU-kontroll: {inspection.label}</span>
              </span>
              <span style={chip(availability.ok ? 'ok' : 'expired')}>{availability.label}</span>
            </Link>
          );
        })}
      </div>
    </>
  );
}
